export default __webpack_public_path__ + "static/media/project3.7ff05d25.png";